import React from 'react';

import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import { makeStyles } from 'tss-react/mui';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogActions from '@mui/material/DialogActions';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import { useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import DialogContent from '@mui/material/DialogContent';

import { displayAlert } from '../../../../slices/feedbackSlice';
import { deleteBook } from '../../../../slices/itemsSlice';

const useStyles = makeStyles()((theme) => ({

  closeButton: {
    position: 'absolute',
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500],
  },
  wrapper: {
    position: 'relative',
  },
  buttonProgress: {
    color: theme.palette.secondary.main,
    position: 'absolute',
    top: '50%',
    left: '50%',
    marginTop: -12,
    marginLeft: -12,
  },
  deleteButton: {
    color: 'darkred',
  },
  actions: {
    justifyContent: 'space-between',
  },
}));

export default function DeleteBookModal({
  display,
  handleClose,
  book,
}) {
  const { classes } = useStyles();
  const dispatch = useDispatch();
  const { t } = useTranslation(['myBooks', 'customers']);

  const handleDelete = () => {
    dispatch(deleteBook(book))
      .unwrap()
      .then(
        () => {
          dispatch(displayAlert(t('delete_modal.success'), 'success'));
          handleClose();
        },
      )
      // ⛔ PAS de `.catch` qui réécrit l'alerte. `deleteBook` a déjà posé le
      // message de l'API, et `displayAlert` n'a qu'un seul emplacement : le
      // dernier écrit gagne. Un message générique ici écrasait donc « Cet
      // ouvrage est prêté et n'a pas encore été rendu. Marquez son retour… »
      // par « Une erreur est survenue. Pouvez-vous réessayer? » — un conseil
      // FAUX, puisque le geste échouera toujours tant que le livre est dehors.
      //
      // ⚠️ Le `catch` reste nécessaire pour que le rejet ne remonte pas en
      // promesse non rattrapée, mais il ne dit plus rien.
      .catch(() => {});
  };

  const modalContent = (
    <>
      <DialogTitle className={classes.root}>
        <Typography type="h3" variant="h3">
          {t('delete_modal.title')}
        </Typography>
        <IconButton
          aria-label="close"
          className={classes.closeButton}
          onClick={handleClose}
          size="large"
        >
          <CloseIcon />
        </IconButton>

      </DialogTitle>
      <DialogContent dividers>

        <Typography type="p" variant="body1">
          {t('delete_modal.delete_book_text')}
        </Typography>
      </DialogContent>

      <DialogActions className={classes.actions}>
        {/* <Grid container alignItems="flex-end" justify="flex-end" direction="row"> */}
        {/*  <Grid item xs={6} className={classes.cancelButton}> */}
        <Button
          variant="contained"
          component="label"
          color="secondary"
          onClick={handleClose}
        >
          {t('delete_modal.cancel_button')}
        </Button>
        {/* </Grid> */}
        {/* <Grid item xs={6} className={classes.deleteButton}> */}
        <Button
          variant="contained"
          component="label"
          color="primary"
          onClick={handleDelete}
        >
          {t('delete_modal.delete_button')}
        </Button>
        {/*  </Grid> */}
        {/* </Grid> */}
      </DialogActions>
    </>
  );

  return (
    <Dialog
      open={display}
      onClose={handleClose}
      fullWidth
    >
      {modalContent}
    </Dialog>
  );
}
